module.exports = __webpack_public_path__ + "static/media/sc111.9aef10d2.svg";